import React from 'react';
import { Link } from 'react-router-dom';
import Rating from './Rating';
import SmartImage from './SmartImage';
import { assetUrl } from '../../config/api';

/** Testimonial card used by the landing rail and the all-reviews page. */
const ReviewCard = ({ review }) => {
  if (!review) return null;

  const image = review.review_image_1 || review.product?.product_image_1;
  const productCode = review.product?.product_code;

  return (
    <article className="ij-card ij-card--review">
      {image && (
        <div className="ij-card__media">
          <SmartImage className="ij-card__img" src={assetUrl(image)} alt="" />
        </div>
      )}

      <div className="ij-card__body">
        <Rating value={review.rating} />
        <p className="ij-card__title">
          {review.review ? `“${review.review}”` : ''}
        </p>
        {review.user_name && (
          <p className="ij-caption">— {review.user_name}</p>
        )}

        {productCode && (
          <div className="ij-card__actions">
            <Link
              to={`/productshow/${productCode}`}
              className="ij-btn ij-btn--outline ij-btn--sm ij-btn--block"
            >
              View product
            </Link>
          </div>
        )}
      </div>
    </article>
  );
};

export default ReviewCard;
